import http from '../utils/http';
import { Dispatch } from 'redux';
import { IApplicationState } from '../reducers';
import actionTypes from '../actions/actionTypes';
import { AxiosResponse } from 'axios';

/**
 * Get all option packs
 */
export function getAllOptionPacks() {
    return async (dispatch: Dispatch, getState: () => IApplicationState) => {
        try {
            const url = `/api/options`;
            const response = await http.get(url);
            // add dispatch to add to current queue; or use state from current file
            dispatch({
                type: actionTypes.GET_ALL_OPTION_PACKS,
                payload: response.data
            });
            return response.data;
        } catch (e) {
            // Remove all questions from list if error occurs

            throw e;
        }
    };
}

/**
 * get option pack by id
 * @param id
 */
export function getOptionPackById(id) {
    return async (dispatch: Dispatch, getState: () => IApplicationState) => {
        const tenantID = getState().authReducer.tenant.tenantId;
        const url = `/api/options/${id}?tenantID=${tenantID}`;
        const response: AxiosResponse<any> = await http.get(url);
        dispatch({
            type: actionTypes.GET_SINGLE_OPTION_PACK,
            payload: response.data
        });
        return response.data;
    };
}

/**
 * Save new option pack
 * @param data
 */
export function saveOptionPack(data) {
    return async (dispatch: Dispatch, getState: () => IApplicationState) => {
        try {
            const url = `/api/options`;
            const response = await http.post(url, data);
            dispatch({
                type: actionTypes.ADD_SINGLE_OPTION_PACK,
                payload: response.data
            });
            return true;
        } catch (err) {
            console.error(err);
            return false;
        }
    };
}

/**
 * Update the option pack
 * @param data
 */
export function updateOptionPack(data) {
    return async (dispatch: Dispatch, getState: () => IApplicationState) => {
        const tenantID = getState().authReducer.tenant.tenantId;
        const url = `/api/options/${data.id}?tenantID=${tenantID}`;
        const response: AxiosResponse<any> = await http.put(url, data);
        dispatch({
            type: actionTypes.GET_SINGLE_OPTION_PACK,
            payload: response.data
        });
        return response.data;
    };
}
/**
 * Duplicate an option pack
 * @param id
 * @param data
 */
export function duplicateOptionPack(id, data) {
    return async (dispatch: Dispatch, getState: () => IApplicationState) => {
        const tenantID = getState().authReducer.tenant.tenantId;
        const url = `/api/optionpack/${id}/duplicate?tenantID=${tenantID}`;
        const response: AxiosResponse<any> = await http.post(url, data);
        dispatch({
            type: actionTypes.GET_SINGLE_OPTION_PACK,
            payload: response.data
        });
        return response.data;
    };
}
/**
 * Delete an option pack
 * @param id
 */
export function deleteOptionPack(id) {
    return async (dispatch: Dispatch, getState: () => IApplicationState) => {
        const tenantID = getState().authReducer.tenant.tenantId;
        const url = `/api/options/${id}?tenantID=${tenantID}`;
        const response: AxiosResponse<any> = await http.delete(url);
        dispatch({
            type: actionTypes.GET_SINGLE_OPTION_PACK,
            payload: response.data
        });
        await dispatch(this.getAllOptionPacks());
        return response.data;
    };
}
